'use client';

import { useState } from 'react';
import { QueryClientProvider, createQueryClient } from '@/lib/useApi';

export function QueryProvider({ children }: { children: React.ReactNode }) {
	const [queryClient] = useState(() => createQueryClient());

	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
